import { createExclusionGroupFcmConfig } from '../shared/builders/exclusionGroup';
import type { FcmConfig } from '../shared/types';

const { name, normalizer, defaultValue } = createExclusionGroupFcmConfig('promote_or_share_slide_up_exclusion_group');

export const FCM_PROMOTE_OR_SHARE_SLIDE_UP_EXCLUSION_GROUP: FcmConfig<typeof defaultValue, typeof defaultValue> = {
	name,
	normalizer,
	defaultValue,
	owner: 'squad-platypus',
	scope: 'corgi-front-end',
	context: 'PSF promote_or_share share slide-up',
	description:
		'Exclusion group for CHANGE-97090: keeps a session bucketed into at most one of the share-slide-up experiments — psf_promote_or_share_whatsapp_channel_experiment (channel-aware WhatsApp CTA) and psf_share_order_localized_experiment. Defaults to no members (all effectively disabled) until weights are set via this admin page. Weights are shares of all slide-up sessions, not shares of sessions eligible for each experiment — the members have different eligibility (WhatsApp arrivals / ranked markets), so a session allocated to one it is not eligible for lands in none. Kept separate from promote_or_share_combo_exclusion_group on purpose: those experiments run on the full combo page, these only on slide-up openers, and mixing the two eligibility levels in one group would starve the slide-up members. Do not change member weights or order while any member is actively collecting data: treatment is sticky per session UUID, so reweighting can flip already-treated sessions into a different bucket without undoing their original treatment, double-counting them. Start a new experiment name instead.',
	template: {
		members: [
			{ experimentId: 'psf_promote_or_share_whatsapp_channel_experiment', weight: 0.5 },
			{ experimentId: 'psf_share_order_localized_experiment', weight: 0.5 },
		],
	},
};
